/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressDecoder,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type ReadonlyUint8Array,
} from '@solana/kit';

export type EntryRegistered = {
  market: Address;
  oracle: Address;
  entryId: ReadonlyUint8Array;
  baseMint: Address;
};

export type EntryRegisteredArgs = EntryRegistered;

export function getEntryRegisteredEncoder(): FixedSizeEncoder<EntryRegisteredArgs> {
  return getStructEncoder([
    ['market', getAddressEncoder()],
    ['oracle', getAddressEncoder()],
    ['entryId', fixEncoderSize(getBytesEncoder(), 32)],
    ['baseMint', getAddressEncoder()],
  ]);
}

export function getEntryRegisteredDecoder(): FixedSizeDecoder<EntryRegistered> {
  return getStructDecoder([
    ['market', getAddressDecoder()],
    ['oracle', getAddressDecoder()],
    ['entryId', fixDecoderSize(getBytesDecoder(), 32)],
    ['baseMint', getAddressDecoder()],
  ]);
}

export function getEntryRegisteredCodec(): FixedSizeCodec<
  EntryRegisteredArgs,
  EntryRegistered
> {
  return combineCodec(getEntryRegisteredEncoder(), getEntryRegisteredDecoder());
}
